import { BRAND, NAV_LINKS } from "@/lib/brand";
import { TiktokIcon } from "@/components/site/BrandIcons";
import { FacebookIconMenu } from "@/components/site/FacebookMenu";
import { Instagram, Youtube } from "lucide-react";

const SOCIALS = [
  { Icon: Instagram, href: BRAND.social.instagram, label: "Instagram", id: "ig" },
  { Icon: TiktokIcon, href: BRAND.social.tiktok, label: "TikTok", id: "tt" },
  { Icon: Youtube, href: BRAND.social.youtube, label: "YouTube", id: "yt" },
];

export default function Footer() {
  return (
    <footer
      className="relative bg-[#030303] border-t border-white/5 pt-24 pb-12"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        {/* Big brand line */}
        <div className="mb-16 border-b border-white/5 pb-16 text-center">
          <img
            src={BRAND.logoImage}
            alt="Crown Jewels Sisterhood Houston"
            className="h-16 sm:h-20 w-auto mx-auto mb-6 drop-shadow-[0_0_24px_rgba(233,30,140,0.45)]"
            data-testid="footer-logo"
          />
          <div
            className="font-script text-brand text-6xl sm:text-7xl lg:text-8xl leading-none"
            data-testid="footer-brand-script"
          >
            Crown Jewels
          </div>
          <div className="text-[11px] uppercase tracking-[0.45em] text-white/50 mt-4">
            Sisterhood · MC · SC · Houston, Texas
          </div>
          <p
            className="font-script text-brand text-3xl sm:text-4xl mt-8 max-w-2xl mx-auto leading-tight"
            data-testid="footer-motto"
          >
            "Like precious jewels, our sisterhood is rare."
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 text-sm">
          <div className="lg:col-span-5 space-y-4">
            <p className="text-white/65 leading-relaxed max-w-sm">
              A sisterhood forged in Houston, {BRAND.mcEst}. Built by queens,
              bonded for life — on the road and off. Our MC rides, our SC
              celebrates, and <strong className="text-white">Miss Crown Jewels</strong>
              {" "}mentors the next generation (ages 2–17).
            </p>
            <div className="flex gap-3" data-testid="footer-socials">
              {SOCIALS.map(({ Icon, href, label, id }) => (
                <a
                  key={id}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  data-testid={`footer-social-${id}`}
                  className="inline-flex items-center justify-center w-10 h-10 border border-white/15 text-white/70 hover:border-brand hover:text-brand transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-4">
              Navigate
            </div>
            <ul className="space-y-2 text-white/75">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="hover:text-brand transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4 space-y-4">
            <div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-2">
                MC
              </div>
              <a
                href={`mailto:${BRAND.emails.mc}`}
                className="text-white hover:text-brand transition-colors break-all"
                data-testid="footer-email-mc"
              >
                {BRAND.emails.mc}
              </a>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-2">
                SC
              </div>
              <a
                href={`mailto:${BRAND.emails.sc}`}
                className="text-white hover:text-brand transition-colors break-all"
                data-testid="footer-email-sc"
              >
                {BRAND.emails.sc}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-white/40">
          <div data-testid="footer-copy">
            © {new Date().getFullYear()} Crown Jewels Sisterhood Houston. All rights reserved.
          </div>
          <div>Ride safe · Love your sister · Wear the crown</div>
        </div>
      </div>
    </footer>
  );
}

